// extracted by mini-css-extract-plugin
module.exports = {"container":"aee5b7c44e--container--gJDfG","content":"aee5b7c44e--content--G1DCn","link":"aee5b7c44e--link--EXp1y","mobile":"aee5b7c44e--mobile--YoxOV"};